// 体检页。**只给我们自己看**，不在运营后台里。
//
// 为什么单独一页、单独一个口令：这上面全是内部口径 —— 错误率、错误类型分布、
// 各道闸拦了多少。挂进运营后台等于迟早被截图转发，而同行已经注册进来探过底了。
//
// 两道闸，缺一不可：
//   1. 必须先登录后台（接口挂在 admin 路由下）
//   2. 进来之后再输一次口令
//
// 口令**不走 URL** —— URL 上的口令会留在浏览器历史、referer、代理和服务器
// 访问日志里，链接漏一次就等于永久公开，爬虫扫到也能看。
// 现在链接和口令同时漏了，没有后台账号照样进不来。
//
// 打开方式：/#/x/4xezpk6zminb，然后输口令。口令存 sessionStorage，关掉标签页就没了。
// 路径段是随机的 —— 它不是安全措施（真防护是登录 + 口令），只是让这一页
// 不落在任何人的猜测范围里。改路径记得同步书签。

import React, { useEffect, useState } from 'react';
import { agentApi } from '../services/api';

// 各环节的人话名字。哪个最烧钱，直接决定该砍哪里
const SCENE = {
  merchant: '跟商家谈',
  merchant2: '跟商家谈（收尾那一句）',
  blogger: '跟博主谈',
  blogger2: '跟博主谈（收尾那一句）',
  guard: '话题护栏判断',
  compliance: '合规闸判断',
  other: '其他',
};

export default function Health() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [key, setKey] = useState(() => sessionStorage.getItem('healthKey') || '');
  const [typing, setTyping] = useState('');
  const [loading, setLoading] = useState(false);

  const open = (k) => {
    if (!k) return;
    setLoading(true); setErr('');
    agentApi.health(k)
      .then((r) => { setD(r); sessionStorage.setItem('healthKey', k); setKey(k); })
      .catch((e) => {
        sessionStorage.removeItem('healthKey');
        setErr(e?.response?.status === 401 || e?.response?.status === 403
          ? '先登录后台再进来' : '口令不对');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { if (key) open(key); /* eslint-disable-next-line */ }, []);

  if (!d) {
    return (
      <div style={s.wrap}>
        <h1 style={s.h1}>体检</h1>
        <div style={s.lead}>
          这页只给自己看。需要<b>先登录后台</b>，再输一次口令 ——
          两样都对才进得来，光有链接没用。
        </div>
        <div style={s.gate}>
          <input
            type="password"
            style={s.input}
            placeholder="口令"
            value={typing}
            autoFocus
            onChange={(e) => setTyping(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') open(typing); }}
          />
          <button style={s.btn} disabled={loading} onClick={() => open(typing)}>
            {loading ? '…' : '进去'}
          </button>
        </div>
        {err && <div style={s.err}>{err}</div>}
      </div>
    );
  }

  const maxTag = Math.max(1, ...d.byTag.map((x) => x.n));
  const queue = d.queue || {};
  const queueTotal = Object.values(queue).reduce((a, b) => a + b, 0);

  return (
    <div style={s.wrap}>
      <h1 style={s.h1}>体检</h1>
      <div style={s.lead}>
        这页回答一件事：<b>它在哪类情况下会错、错多少、哪类最贵。</b>
        数据来自运营每一次「改了助理做错的地方」—— 真实分布，不是我们编的用例。
      </div>

      {/* 技术面。只放两类：花钱，和它是不是还活着。
          其余（CPU/QPS/查询数）看了也不会改变任何决定，不放。 */}
      <h2 style={s.h2}>机器这边<span style={s.sub}>　只放会改变决定的</span></h2>
      <div style={s.cards}>
        <div style={s.card}>
          <div style={s.cardN}>${d.tech?.llmDay?.usd ?? 0}</div>
          <div style={s.cardL}>今天的模型花费<br /><span style={s.cardSub}>近七天 ${d.tech?.llmWeek?.usd ?? 0}</span></div>
        </div>
        <div style={s.card}>
          <div style={s.cardN}>{d.tech?.llmDay?.calls ?? 0}</div>
          <div style={s.cardL}>今天调了几次<br /><span style={s.cardSub}>平均 {d.tech?.llmDay?.avgMs ?? 0}ms</span></div>
        </div>
        <div style={s.card}>
          <div style={{ ...s.cardN, color: (d.tech?.llmDay?.failRate || 0) > 2 ? '#b91c1c' : undefined }}>
            {d.tech?.llmDay?.failRate ?? 0}%
          </div>
          <div style={s.cardL}>调用失败率<br /><span style={s.cardSub}>失败 {d.tech?.llmDay?.failed ?? 0} 次</span></div>
        </div>
        <div style={s.card}>
          <div style={{ ...s.cardN, color: (d.tech?.sweep?.minsSinceOk ?? 999) > 20 ? '#b91c1c' : undefined }}>
            {d.tech?.sweep?.minsSinceOk ?? '—'}
          </div>
          <div style={s.cardL}>调度器多久没成功了（分钟）<br /><span style={s.cardSub}>正常 &lt; 10</span></div>
        </div>
        <div style={s.card}>
          <div style={{ ...s.cardN, color: (d.tech?.mem?.freeMb ?? 999) < 120 ? '#b91c1c' : undefined }}>
            {d.tech?.mem?.freeMb ?? '—'}M
          </div>
          <div style={s.cardL}>机器还剩多少内存<br /><span style={s.cardSub}>共 {d.tech?.mem?.totalMb ?? '—'}M · 我们占 {d.tech?.mem?.rssMb ?? '—'}M</span></div>
        </div>
      </div>
      <div style={s.note}>
        <b>调用失败率</b>要盯：它一高，助理会<b>静默变笨</b> —— 不报错，只是回得敷衍，
        这是最不容易发现的一类故障。<br />
        <b>调度器多久没成功</b>超过 20 分钟就是它死了：超时不换人、不催到店、不催发布，
        整条流水线安静地停掉，而且不会有人来报错，因为「没有消息」看起来就像「没有事发生」。
      </div>
      {!!(d.tech?.byScene || []).length && (
        <table style={{ ...s.tbl, marginTop: 14 }}>
          <thead><tr><th style={s.th}>哪个环节（近七天）</th><th style={s.th}>调用次数</th><th style={s.th}>花费</th></tr></thead>
          <tbody>
            {d.tech.byScene.map((x) => (
              <tr key={x.scene}>
                <td style={s.td}>{SCENE[x.scene] || x.scene}</td>
                <td style={s.td}>{x.calls}</td>
                <td style={s.td}>${x.usd}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* 撮合漏斗：哪一步掉人最多。比总量有用得多 ——
          「邀 100 个成 3 个」和「邀 100 个回了 60 个但都没定下时间」
          是完全不同的两个问题：前者选错人，后者谈不拢。 */}
      <h2 style={s.h2}>每一步掉了多少人<span style={s.sub}>　已排除 {d.excludedTest} 个测试博主</span></h2>
      <div style={s.funnel}>
        {(d.funnel || []).map((f, i, arr) => {
          const prev = i ? arr[i - 1].n : f.n;
          const keep = prev ? Math.round((f.n / prev) * 100) : 0;
          const wide = arr[0].n ? Math.max(4, (f.n / arr[0].n) * 100) : 4;
          return (
            <div key={f.step} style={s.fRow}>
              <div style={s.fLabel}>{f.step}</div>
              <div style={s.fTrack}><div style={{ ...s.fFill, width: `${wide}%` }} /></div>
              <div style={s.fNum}>{f.n}{i > 0 && <span style={s.fPct}>　留下 {keep}%</span>}</div>
            </div>
          );
        })}
      </div>

      {/* 回话有多快。中位数比平均实在 —— 一个人隔三天才回会把平均拉得面目全非 */}
      <h2 style={s.h2}>他们多久回话<span style={s.sub}>　{d.replySpeed?.n || 0} 条有回应的单子</span></h2>
      <div style={s.cards}>
        <div style={s.card}><div style={s.cardN}>{d.replySpeed?.p50 ?? '—'}</div><div style={s.cardL}>一半人在这么多小时内回</div></div>
        <div style={s.card}><div style={s.cardN}>{d.replySpeed?.p90 ?? '—'}</div><div style={s.cardL}>九成人在这么多小时内回</div></div>
      </div>
      <div style={s.note}>
        中位数明显大于「超时换人」的阈值（默认 5 小时），说明阈值定短了，
        在把本来会回的人踢掉。
      </div>

      {/* 谈成一单要来回几轮 —— 「用起来顺不顺」唯一能一眼看见的数字 */}
      <h2 style={s.h2}>谈成一单要来回几轮<span style={s.sub}>　{d.roundsToClose?.n || 0} 条定下时间的单子</span></h2>
      <div style={s.cards}>
        <div style={s.card}>
          <div style={s.cardN}>{d.roundsToClose?.p50 ?? '—'}</div>
          <div style={s.cardL}>一半的单子，博主开口这么多次就定了</div>
        </div>
        <div style={s.card}>
          <div style={s.cardN}>{d.roundsToClose?.p90 ?? '—'}</div>
          <div style={s.cardL}>九成的单子在这个数以内</div>
        </div>
        <div style={s.card}>
          <div style={{ ...s.cardN, color: (d.roundsToClose?.longTail ?? 0) > 20 ? '#FA1C51' : undefined }}>
            {d.roundsToClose?.longTail ?? '—'}%
          </div>
          <div style={s.cardL}>超过 6 轮才谈完的</div>
        </div>
      </div>
      <div style={s.note}>
        漏斗告诉你在哪一步掉人，但掉人的原因常常是<b>「太啰嗦，他懒得回了」</b>——
        那件事漏斗上看不见。三轮谈完和八轮谈完，成功率可能一样，体验差得远。
        <br />
        2026-09-21 就吃过这个亏：初次问条件本该问 3 个，因为一个默认值没生效变成问 7 个，
        老板答到第三轮就不回了 —— 当时所有断言都是绿的。<b>这个数字盯着别往上走。</b>
      </div>

      {/* 邀请集中度 —— 是不是老在薅同几个人 */}
      <h2 style={s.h2}>邀请是不是集中在少数人身上</h2>
      <div style={s.cards}>
        <div style={s.card}><div style={s.cardN}>{d.concentration?.top20pct ?? 0}%</div><div style={s.cardL}>最活跃的两成人<br />拿走了这么多邀请</div></div>
        <div style={s.card}><div style={s.cardN}>{d.concentration?.people ?? 0}</div><div style={s.cardL}>被邀请过的人数</div></div>
        <div style={s.card}><div style={s.cardN}>{d.concentration?.never ?? 0}</div><div style={s.cardL}>一次都没被邀过</div></div>
      </div>
      <div style={s.note}>
        两成人拿走七成以上邀请，就是在薅同几个人 —— 他们会烦，而新人永远攒不出履约记录。
        「一次都没被邀过」的人数一直不降，说明池子在闲置。
      </div>

      {/* 画像完整度 —— 匹配准不准，一半取决于这几个字段有没有值 */}
      <h2 style={s.h2}>画像有多少是空的<span style={s.sub}>　{d.filled?.total || 0} 位正式博主</span></h2>
      <div style={s.cards}>
        {[
          ['填了常去区域', d.filled?.areas],
          ['填了有空时段', d.filled?.availability],
          ['抓到了粉丝数', d.filled?.fans],
        ].map(([label, n]) => (
          <div key={label} style={s.card}>
            <div style={s.cardN}>{d.filled?.total ? Math.round(((n || 0) / d.filled.total) * 100) : 0}%</div>
            <div style={s.cardL}>{label}<br /><span style={s.cardSub}>{n || 0} / {d.filled?.total || 0}</span></div>
          </div>
        ))}
      </div>
      <div style={s.note}>
        这三项是匹配里权重最高的几维。填充率低的时候，「匹配不准」多半不是模型弱，
        是没数据可用 —— 这种情况调 prompt 是白费力气。
      </div>

      {/* 履约异常 —— 看起来正常但其实出事了的那些，最不容易被发现 */}
      <h2 style={s.h2}>悄悄出事的<span style={s.sub}>　没人会来报这类错</span></h2>
      <div style={s.cards}>
        {[
          ['没去也没说一声', d.trouble?.noShow],
          ['临时放鸽子', d.trouble?.cancelledLate],
          ['发了又删', d.trouble?.postGone],
          ['商家说时间不行', d.trouble?.merchantObjected],
        ].map(([label, n]) => (
          <div key={label} style={s.card}><div style={s.cardN}>{n ?? 0}</div><div style={s.cardL}>{label}</div></div>
        ))}
      </div>

      {/* 1. 错误类型分布 —— 「不知道漏在哪」就是靠这张表变成「漏在 A」 */}
      <h2 style={s.h2}>错在哪一类<span style={s.sub}>　共 {d.total} 条修正</span></h2>
      {d.total === 0 ? (
        <div style={s.empty}>还没有数据。让运营先用一阵子 —— 他每处理一条待办、
          退一篇稿、拒一条画像，就会顺手点一下「哪儿不对」，这里就会长出来。</div>
      ) : (
        <div style={s.bars}>
          {d.byTag.map((x) => (
            <div key={x.tag} style={s.barRow}>
              <div style={s.barLabel}>{x.label}</div>
              <div style={s.barTrack}>
                <div style={{ ...s.barFill, width: `${(x.n / maxTag) * 100}%` }} />
              </div>
              <div style={s.barNum}>{x.n} 条 · {x.pct}%</div>
            </div>
          ))}
        </div>
      )}

      {/* 2. 每周修正率 —— 一条会动的线。不往下走，说明优化是错觉 */}
      <h2 style={s.h2}>每周修正率<span style={s.sub}>　修正数 ÷ 助理开口的条数</span></h2>
      {!d.weekly.length ? <div style={s.empty}>还没有</div> : (
        <table style={s.tbl}>
          <thead><tr><th style={s.th}>周</th><th style={s.th}>助理说了</th><th style={s.th}>被改</th><th style={s.th}>修正率</th></tr></thead>
          <tbody>
            {d.weekly.map((w) => (
              <tr key={w.week}>
                <td style={s.td}>{w.week}</td>
                <td style={s.td}>{w.said}</td>
                <td style={s.td}>{w.fixes}</td>
                <td style={{ ...s.td, fontWeight: 700 }}>{w.rate === null ? '—' : `${w.rate}%`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* 3. 不确定队列 —— 队列多长 = 系统真实的不确定区域有多大 */}
      <h2 style={s.h2}>「我不确定」的队列<span style={s.sub}>　共 {queueTotal} 条等人</span></h2>
      <div style={s.cards}>
        {[
          ['转人工的对话', queue.handoff],
          ['等审的稿子', queue.draftWait],
          ['等审的画像', queue.signalWait],
          ['认不出的店', queue.unmatched],
          ['谈成待确认', queue.agreedWait],
        ].map(([label, n]) => (
          <div key={label} style={s.card}><div style={s.cardN}>{n ?? 0}</div><div style={s.cardL}>{label}</div></div>
        ))}
      </div>
      <div style={s.note}>
        队列不是坏事 —— 一个不许说「我不确定」的系统一定会瞎编。
        但队列一直变长，说明不确定的区域在扩大，值得看一眼是哪一类。
      </div>

      {/* 4. 各道闸拦了多少 —— 拦得多不一定好，也可能是误伤 */}
      <h2 style={s.h2}>各道闸拦下了什么<span style={s.sub}>　近八周</span></h2>
      {!d.gates.length ? <div style={s.empty}>还没有</div> : (
        <table style={s.tbl}>
          <tbody>
            {d.gates.map((g, i) => (
              <tr key={i}><td style={s.td}>{g.why}</td><td style={{ ...s.td, width: 80, textAlign: 'right' }}>{g.n}</td></tr>
            ))}
          </tbody>
        </table>
      )}

      {/* 5. 最近的原始修正 —— 分布告诉你往哪看，这里告诉你到底错成什么样 */}
      <h2 style={s.h2}>最近的修正<span style={s.sub}>　点开看当时错成什么样</span></h2>
      {!d.recent.length ? <div style={s.empty}>还没有</div> : d.recent.map((r) => (
        <details key={r._id} style={s.det}>
          <summary style={s.sum}>
            <span style={s.tag}>{r.tag}</span>
            <span style={s.src}>{r.source}</span>
            <span style={s.when}>{String(r.createdAt).slice(0, 16).replace('T', ' ')}</span>
            <span style={s.who}>{r.by}</span>
          </summary>
          {r.note && <div style={s.detLine}><b>运营写的：</b>{r.note}</div>}
          {r.aiOutput && <div style={s.detLine}><b>助理当时：</b><pre style={s.pre}>{r.aiOutput}</pre></div>}
          {r.opsFixed && <div style={s.detLine}><b>改成了：</b><pre style={s.pre}>{r.opsFixed}</pre></div>}
        </details>
      ))}

      {/* 说了没做 —— 放在最前面几块之后，因为它是最伤人的一类 */}
      <h2 style={s.h2}>
        嘴上说了，实际没做
        <span style={s.sub}>　共 {d.mismatch?.total ?? 0} 条，最近七天 {d.mismatch?.thisWeek ?? 0} 条</span>
      </h2>
      <div style={s.note}>
        助理说「已经为您安排在周五 11 点」，可库里根本没记下这个时间。
        <b>断言抓不到</b>（说的话本身没毛病）、<b>flowlint 也抓不到</b>（读起来很通顺）——
        只有把「说的」和「做的」摆一起才看得见。而对方收到的是一句斩钉截铁的承诺，
        我们这边一片安静：博主按承诺的时间真去了，店里没人接待。
        <br />
        盯两个数：<b>总量别往上走</b>；<b>哪一类最多就先修哪一类</b>。
      </div>
      {!d.mismatch?.total ? (
        <div style={s.empty}>还没有 —— 要么真没发生，要么这几条规则没覆盖到</div>
      ) : (
        <>
          <table style={s.tbl}>
            <tbody>
              {d.mismatch.byKind.map((x) => (
                <tr key={x.kind}>
                  <td style={s.td}>{x.kind}</td>
                  <td style={{ ...s.td, width: 80, textAlign: 'right' }}>{x.n}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {d.mismatch.recent.map((r, i) => (
            <details key={i} style={s.det}>
              <summary style={s.sum}>
                <span style={s.tag}>{r.promise}</span>
                <span style={s.src}>{r.party === 'merchant' ? '商家' : '博主'}</span>
                <span style={s.when}>{String(r.at).slice(0, 16).replace('T', ' ')}</span>
              </summary>
              {r.context && <div style={s.detLine}><b>对方说：</b>{r.context}</div>}
              <div style={s.detLine}><b>助理答：</b><pre style={s.pre}>{r.said}</pre></div>
              <div style={s.detLine}>
                <b>本该调：</b>{(r.expected || []).join(' / ')}　
                <b>实际调了：</b>{(r.toolsCalled || []).join(' / ') || '一个都没调'}
              </div>
            </details>
          ))}
        </>
      )}

      {/* 6. 审题面的进度。做题的人看不到这张表 —— 看了会被别人的判断带跑 */}
      <h2 style={s.h2}>审题面<span style={s.sub}>　模型编的题，像不像真人说的</span></h2>
      {!d.evalReview?.total ? <div style={s.empty}>题库还是空的（先跑 eval/bootstrap.js 再导入）</div> : (
        <>
          <div style={s.note}>
            判了 {d.evalReview.reviewed} / {d.evalReview.total} 条。
            某一族「像」的比例低，说明<b>那一族的题要重写</b>，不是助理答错了。
          </div>
          {d.evalReview.groups.map((g) => (
            <div key={g.name} style={s.barRow}>
              <span style={s.barLabel}>{g.name}</span>
              <span style={s.barTrack}>
                <span style={{ ...s.barFill, width: `${g.likeRate ?? 0}%`,
                  background: (g.likeRate ?? 100) < 60 ? '#FA1C51' : '#16a34a' }} />
              </span>
              <span style={s.barNum}>{g.likeRate === null ? '—' : `${g.likeRate}%`}</span>
            </div>
          ))}
          {!!d.evalReview.rewrites.length && (
            <>
              <div style={{ ...s.h2, fontSize: 15, borderTop: 'none', paddingTop: 10 }}>
                他们改的那些话<span style={s.sub}>　这批最值钱，直接能搬进 scenarios.js</span>
              </div>
              {d.evalReview.rewrites.map((r, i) => (
                <div key={i} style={s.det}>
                  <div style={{ fontSize: 13, color: '#9ca3af', textDecoration: 'line-through' }}>{r.say}</div>
                  <div style={{ fontSize: 14, marginTop: 4 }}>→ {r.rewrite}　<span style={s.dim}>{r.by}</span></div>
                </div>
              ))}
            </>
          )}
        </>
      )}

      {/* 7. 能拧的旋钮 —— 上面几张表说「哪儿不对」，这张说「有什么能调、现在调到几」 */}
      <h2 style={s.h2}>能拧的旋钮<span style={s.sub}>　线上此刻实际生效的值，只读</span></h2>
      {!(d.settings || []).length ? <div style={s.empty}>后端还没返回</div> : (
        <table style={s.tbl}>
          <tbody>
            {d.settings.map((t) => (
              <tr key={t.key}>
                <td style={s.td}>
                  <div style={{ fontWeight: 600 }}>{t.label}</div>
                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}><code>{t.key}</code></div>
                  {t.note && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>{t.note}</div>}
                </td>
                <td style={{ ...s.td, width: 130, textAlign: 'right', verticalAlign: 'top' }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{t.isDefault ? t.def : t.value}</div>
                  {/* 「有人设过」和「在吃默认值」行为一样，但一个是决定、一个是没人管过 */}
                  <div style={{ fontSize: 12, color: t.isDefault ? '#9ca3af' : '#16a34a', marginTop: 2 }}>
                    {t.isDefault ? '默认值' : '设过了'}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div style={s.note}>
        改法：服务器 <code>.env</code> 加一行，<code>systemctl restart rednote-backend</code>。
        这里只看不给改 —— 一个网页能改线上参数，迟早有人手滑。
      </div>

      <div style={s.foot}>
        下一步：修正攒到一两百条就导出冻成测试集（<code>node eval/freeze.js</code>），
        以后每次改 prompt 前后各跑一遍，防止修好 A 的同时弄坏 B。详见 <code>backend/eval/README.md</code>。
      </div>
    </div>
  );
}

const s = {
  gate: { display: 'flex', gap: 8, marginTop: 18, maxWidth: 320 },
  input: { flex: 1, border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px', fontSize: 14, outline: 'none' },
  btn: { border: 'none', background: '#FA1C51', color: '#fff', borderRadius: 8, padding: '10px 20px', fontSize: 14, cursor: 'pointer' },
  wrap: { maxWidth: 860, margin: '0 auto', padding: '32px 20px 80px', fontFamily: '-apple-system,"PingFang SC","Microsoft YaHei",sans-serif', color: '#18181b' },
  h1: { fontSize: 26, fontWeight: 800, margin: '0 0 10px' },
  h2: { fontSize: 17, fontWeight: 700, margin: '34px 0 12px', paddingTop: 18, borderTop: '1px solid #eee' },
  sub: { fontSize: 13, fontWeight: 400, color: '#9ca3af' },
  lead: { fontSize: 14, color: '#374151', background: '#fafafa', borderLeft: '3px solid #FA1C51', padding: '12px 14px', borderRadius: '0 8px 8px 0' },
  dim: { color: '#9ca3af' },
  err: { color: '#b91c1c' },
  empty: { color: '#9ca3af', fontSize: 14, lineHeight: 1.8 },
  bars: { display: 'flex', flexDirection: 'column', gap: 10 },
  barRow: { display: 'flex', alignItems: 'center', gap: 12, fontSize: 13 },
  barLabel: { width: 190, flexShrink: 0 },
  barTrack: { flex: 1, height: 16, background: '#f3f4f6', borderRadius: 4, overflow: 'hidden' },
  barFill: { height: '100%', background: '#FA1C51' },
  barNum: { width: 110, textAlign: 'right', color: '#6b7280', flexShrink: 0 },
  tbl: { width: '100%', borderCollapse: 'collapse', fontSize: 13.5 },
  th: { textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: '7px 8px', color: '#6b7280', fontWeight: 600 },
  td: { borderBottom: '1px solid #f3f4f6', padding: '7px 8px' },
  funnel: { display: 'flex', flexDirection: 'column', gap: 9 },
  fRow: { display: 'flex', alignItems: 'center', gap: 12, fontSize: 13 },
  fLabel: { width: 90, flexShrink: 0 },
  fTrack: { flex: 1, height: 18, background: '#f3f4f6', borderRadius: 4, overflow: 'hidden' },
  fFill: { height: '100%', background: '#FA1C51', opacity: .85 },
  fNum: { width: 140, textAlign: 'right', color: '#374151', flexShrink: 0 },
  fPct: { color: '#9ca3af', fontSize: 12 },
  cardSub: { color: '#9ca3af', fontSize: 11 },
  cards: { display: 'flex', gap: 10, flexWrap: 'wrap' },
  card: { flex: '1 1 120px', border: '1px solid #e5e7eb', borderRadius: 10, padding: '14px 12px', textAlign: 'center' },
  cardN: { fontSize: 24, fontWeight: 800 },
  cardL: { fontSize: 12.5, color: '#6b7280', marginTop: 4 },
  note: { fontSize: 13, color: '#6b7280', marginTop: 12, lineHeight: 1.8 },
  det: { borderBottom: '1px solid #f3f4f6', padding: '8px 0' },
  sum: { cursor: 'pointer', fontSize: 13, display: 'flex', gap: 10, alignItems: 'center' },
  tag: { background: '#fff1f4', color: '#FA1C51', borderRadius: 4, padding: '2px 8px', fontSize: 12 },
  src: { color: '#6b7280', fontSize: 12 },
  when: { color: '#9ca3af', fontSize: 12, marginLeft: 'auto' },
  who: { color: '#9ca3af', fontSize: 12 },
  detLine: { fontSize: 13, margin: '8px 0 0', lineHeight: 1.7 },
  pre: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#fafafa', padding: 10, borderRadius: 6, margin: '4px 0 0', fontSize: 12.5 },
  foot: { marginTop: 40, paddingTop: 16, borderTop: '1px solid #eee', fontSize: 13, color: '#6b7280', lineHeight: 1.9 },
};
